import React, { Component } from 'react';

class Title extends Component {
    render(){
        return (
                <section className="content-header">
                    <h1>Statistik Punkte-Verbrauch</h1>
                </section>
        );
    }
}

export default Title